<div id="mainRouterContainer" [class.onNewUI]="isNewUI" [class.inGuestView]="inGuestView" [class]="R.orientation + ' ' + R.device + ' ' + R.responsive">
    <div [id]="R.session.value ? 'postLoginContainer' : 'preLoginContainer'" [class.hasLeftNav]="isNewUI && !inGuestView" [class.inGuestView]="inGuestView">
        <ng-container *ngIf="R.session.value && !inGuestView && !hideHeader">
            <ng-container *ngIf="!isNewUI">
                <app-taxilla-header [loading]="R.loadingCall"></app-taxilla-header>
            </ng-container>
            <ng-container *ngIf="isNewUI">
                <app-header [loading]="R.loadingCall"></app-header>
            </ng-container>
        </ng-container>
        <div class="leftNavContainer align-top w-[60px] inline-block h-full" *ngIf="R.session.value && isNewUI && !inGuestView && !hideHeader">
            <app-left-nav-bar></app-left-nav-bar>
        </div>
        <div class="routerOutlet" [ngClass]="{ 'w-[calc(100%-60px)]': !inGuestView && isNewUI && !hideHeader, 'inline-block': isNewUI && !hideHeader, 'w-full': inGuestView || hideHeader}" [hidden]="R.loggingIn || hideBody">
            <router-outlet></router-outlet>
        </div>
        <ng-container *ngIf="R.session.value && hasOrgId?.length > 0">
            <app-postloginfooter></app-postloginfooter>
        </ng-container>
    </div>
</div>
<loader></loader>
<div class="supportSystem" *ngIf="supportSystem">
    <ng-container *transloco="let translate;">
        <div class="btn-number">
            <a *ngIf="supportSystem.helpDeskNumber">
                <material-button [buttonType]="'icon'" [size]="'small'" [classList]="['!text-[#000000]','!bg-white']" [suffixIconAppearance]="'filled'" [suffixIcon]="'call'" [titleText]="translate('Help Desk Number') + ' : ' + supportSystem.helpDeskNumber" [color]="'default'"></material-button>
            </a>
        </div>
        <div class="btn-email">
            <a *ngIf="supportSystem.helpDeskEmail" [href]="'mailto:' + supportSystem.helpDeskEmail" target="_blank" rel="noopener noreferrer">
                <material-button [buttonType]="'icon'" [size]="'small'" [classList]="['!text-[#000000]','!bg-white']" [suffixIconAppearance]="'filled'" [suffixIcon]="'mail'" [titleText]="translate('Help Desk Email') + ' : ' + supportSystem.helpDeskEmail" [color]="'default'"></material-button>
            </a>
        </div>
        <div class="btn-url">
            <a [href]="supportSystem.url" target="_blank">
                <material-button [buttonType]="'icon'" [size]="'small'" [classList]="['!text-[#000000]','!bg-white']" [suffixIconAppearance]="'filled'" [suffixIcon]="'communication'" [titleText]="translate('Open Support') + ' : ' + supportSystem.url" [color]="'default'"></material-button>
            </a>
        </div>
    </ng-container>
</div>
